export default __webpack_public_path__ + "static/spotify-podcast-badge-blk-grn-165x40-e5014def49930d292e8a527d75089726.svg";